import React from 'react';
import ContentLoader from 'react-content-loader';
import { up } from 'styled-breakpoints';
import styled from 'styled-components';

const HeaderPlaceholder = () => (
  <Header>
    <Logo>
      <rect x="0" y="0" rx="0" ry="0" width="190" height="32" />
    </Logo>
    <HeaderButtons>
      <rect x="0" y="0" rx="0" ry="0" width="100" height="38" />
    </HeaderButtons>
  </Header>
);

const Header = styled.div`
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 72px;
  background-color: ${(props) => props.theme.colors.white};

  ${up('sm')} {
    padding: 0 10px;
    height: 64px;
  }

  ${up('lg')} {
    padding: 0 64px;
  }
`;

const Logo = styled(ContentLoader)`
  height: 32px;
  width: 190px;
`;

const HeaderButtons = styled(ContentLoader)`
  width: 100px;
  height: 38px;
`;

export default HeaderPlaceholder;
